const ChatHeaderSkeleton = (props: any) => {
    const classToAdd = props.className ?? '';
    return <div className={`chat-skeleton-header ${classToAdd}`}></div>
}
export default ChatHeaderSkeleton;